<template>
  <div class="cmp-wrapper">
    <basic-container>
      <mc-slider />
    </basic-container>
  </div>
</template>


<script>
import McSlider from "./../../../blocks/mc-slider/index.js";

export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {
    McSlider
  }
};
</script>


<style lang="scss" scoped>
.cmp-wrapper {
}
</style>
